module.exports = __webpack_public_path__ + "img/img01.16a6fb21.png";